import { subscribeSystemNoticePresented } from "@/lib/onboarding-system-notices";

const DESKTOP_UPDATE_NOTIFICATION_DAY_KEY =
  "denker.desktop_update_notification.last_day";

let inMemoryLastDay: string | null = null;

function localDayKey(now: Date): string {
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function getLocalStorage(): Storage | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

function persistDay(day: string): void {
  inMemoryLastDay = day;
  try {
    getLocalStorage()?.setItem(DESKTOP_UPDATE_NOTIFICATION_DAY_KEY, day);
  } catch {
    // The in-memory gate still prevents repeated prompts in this app session.
  }
}

subscribeSystemNoticePresented((toast) => {
  if (toast.id === "desktop-auto-update") persistDay(localDayKey(new Date()));
});

export function shouldShowDesktopUpdateNotification(now = new Date()): boolean {
  const currentDay = localDayKey(now);
  const storage = getLocalStorage();

  try {
    if (storage?.getItem(DESKTOP_UPDATE_NOTIFICATION_DAY_KEY) === currentDay) {
      inMemoryLastDay = currentDay;
      return false;
    }
  } catch {
    // Fall through to the in-memory gate.
  }

  if (inMemoryLastDay === currentDay) return false;
  // Queuing an update does not consume its daily allowance. Only presentation
  // or an explicit snooze marks it seen, including while the trial goes first.
  return true;
}

export function snoozeDesktopUpdateNotification(now = new Date()): void {
  persistDay(localDayKey(now));
}

export function resetDesktopUpdateNotificationGate(): void {
  inMemoryLastDay = null;
  try {
    getLocalStorage()?.removeItem(DESKTOP_UPDATE_NOTIFICATION_DAY_KEY);
  } catch {
    // Test/session cleanup remains best-effort.
  }
}
